/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_NeckInputs */

const en_us2_catalog_movement_neck = /** @type {(inputs: Catalog_Movement_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`neck`)
};

const pt_br2_catalog_movement_neck = /** @type {(inputs: Catalog_Movement_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pescoço`)
};

const es_419_catalog_movement_neck = /** @type {(inputs: Catalog_Movement_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cuello`)
};

const pt_pt2_catalog_movement_neck = /** @type {(inputs: Catalog_Movement_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pescoço`)
};

const fr_fr2_catalog_movement_neck = /** @type {(inputs: Catalog_Movement_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cou`)
};

const de_de2_catalog_movement_neck = /** @type {(inputs: Catalog_Movement_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacken`)
};

const it_it2_catalog_movement_neck = /** @type {(inputs: Catalog_Movement_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`collo`)
};

/**
* | output |
* | --- |
* | "neck" |
*
* @param {Catalog_Movement_NeckInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_neck = /** @type {((inputs?: Catalog_Movement_NeckInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_NeckInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_neck(inputs)
	if (locale === "es-419") return es_419_catalog_movement_neck(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_neck(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_neck(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_neck(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_neck(inputs)
	return en_us2_catalog_movement_neck(inputs)
});
export { catalog_movement_neck as "catalog.movement.neck" }